import type { SVGProps } from 'react';
const SvgLevel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path fill="currentColor" d="M3 14.797v2.899h20v-2.899zM3 9v2.899h20V9z" />
  </svg>
);
export default SvgLevel;
